import { useRouter } from 'next/router';
import React from 'react';
import JSONLDHead from '~/components/JSONLDHead';
import { jsonLDHelpers } from '~/utils/jsonLD';

function JsonLDRestaurant(props) {
  const router = useRouter();
  const restaurant = props.restaurant;

  if (!restaurant) {
    return null;
  }
  const prodRestaurantUrl = `https://www.chowbus.com${router.asPath}`;
  const { name, imageUrl, phoneNumber } = restaurant.attributes;
  const { attributes: addressInfo } = restaurant.relationships.address.data;
  const structuredData = jsonLDHelpers.createStructuredRestaurantData({
    menuUrl: prodRestaurantUrl,
    name,
    imageUrl,
    address: addressInfo,
    phoneNumber,
  });

  return <JSONLDHead jsonLD={structuredData} />;
}

export default JsonLDRestaurant;
